// Carries a form_submission dataLayer event across a redirect to a thank-you
// page. Pushed on the form's own page, the event raced the page unload, so GTM
// often never saw it and it was gone from window.dataLayer before anyone could
// inspect it. Instead formSubmission.js queues it here and the next page load
// pushes it, once, as soon as site.js runs.

const STORAGE_KEY = 'pending-form-submission';

/**
 * Saves the event for the next page load. Returns false when sessionStorage is
 * unavailable (private mode, blocked site data), so the caller can push it
 * straight away instead.
 *
 * @param {object} data
 * @returns {boolean}
 */
export const queueFormSubmission = (data) => {
    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));

        return true;
    } catch (e) {
        return false;
    }
};

const pushQueuedFormSubmission = () => {
    let data = null;

    try {
        data = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
        window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        return;
    }

    if (!data) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};

pushQueuedFormSubmission();
